<script>
    import {supabase} from './supabaseClient';  
    import Excerpts from "./excerpts/Excerpts.svelte";
    import Bookmarks from "./bookmarks/Bookmarks.svelte";
    import Navbar from "./utils/Navbar.svelte";
    import { util as bookmarksUtil } from './utils/bookmarksUtil.js';
    import { util as excerptsUtil } from './utils/excerptsUtil.js';

    export let view = 'excerpts';

    //There's no specific password reset page for now. 
    //To reset passwords, append ?action=password-reset to any URL.
    let action = new URLSearchParams(window.location.search).get("action");
    console.log(action);
    if (action == 'password-reset') {
        let name = ' ' + supabase.auth.user()?.email?.split('@')[0];
        let newPassword = prompt(`Hi${name}, enter your new password`);
        try {
            supabase.auth.update({
                password: newPassword
            }).then((data, error) => {
                console.log(data);
                if (error) {throw error};
                alert('Password changed!');
            })
        } catch (error) {
            alert(error.error_description || error.message)
        }
    }

    let inputLink;
    let inputSource;
    let inputText;
    //When shared in Android, this "text" can be a link or an excerpt.
    let inputTextFromQuery = new URLSearchParams(window.location.search).get("text");
    let inputTitleFromQuery = new URLSearchParams(window.location.search).get("title");
    if (inputTextFromQuery != null && inputTextFromQuery != '') {
        inputLink = bookmarksUtil.extractLink(inputTextFromQuery, inputTitleFromQuery);
        if (inputLink != null && inputLink != '') {
            console.debug({inputTextFromQuery, inputLink});
            view = 'bookmarks';
        } else {
            let extractedText = excerptsUtil.extractText(inputTextFromQuery);
            inputText = extractedText.text;
            inputSource = extractedText.source;   
            console.debug({inputTextFromQuery, text: extractedText.text, source: extractedText.source}); 
            view = 'excerpts';
        }
    }
</script>

<div id="view-container">
    <Navbar bind:view={view}/>
    {#if view == 'bookmarks'}
        <Bookmarks inputLink={inputLink}/>
    {:else}
        <Excerpts inputText={inputText} inputSource={inputSource}/>
    {/if}
</div>

<style>
    #view-container {
        max-width: 80%;
        margin: 2em auto;
    }
</style>